<!--
 * @Author: LiuXin
 * @Date: 2021-12-02 19:06:48
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-12-28 16:43:26
-->
<template>
  <a-space :size="12">
    <a-select v-if="index" class="w64" v-model:value="rule.orAnd" :options="orAndOptions" @change="orAndChange"> </a-select>
    <a-select v-show="showBox('field')" style="width: 150px" :value="ruleFiled" :options="indicatorOptions" placeholder="选择指标" label-in-value @change="fieldChange" v-bind="$filterOptions"></a-select>
    <a-select v-show="showBox('condition')" style="width: 150px" v-model:value="rule.condition" :options="conditionOptions" placeholder="选择条件"></a-select>
    <a-select v-if="showBox('targetField')" style="width: 150px" :value="targetField" :options="targetFieldOptions" placeholder="选择参考类型" label-in-value @change="targetFieldChange"></a-select>
    <a-input v-if="showBox('value')" style="width: 150px" v-model:value.trim="rule.value" placeholder="请输入数值" :suffix="getSuffix"></a-input>
    <SelectMultiple v-if="showBox('include')" :value="targetField" :select-data="targetField" :select-options="targetFieldOptions" :allow-clear="true" mode="multiple" :label-in-value="true" placeholder="选择参考类型" v-bind="$filterOptions" option-label-prop="label" :max-tag-count="1" :show-arrow="true" :dropdown-match-select-width="false" select-option-value="value" select-option-label="label" style="width: 150px" @change="includeChange" />
    <a-radio-group v-show="showBox('compareModel')" v-model:value="rule.compareModel" class="radio-group">
      <a-radio :value="1">今日累计</a-radio>
      <a-radio :value="2">近三日累计</a-radio>
      <a-radio :value="3">近七日累计</a-radio>
    </a-radio-group>
  </a-space>
</template>

<script>
import SelectMultiple from '@/components/selectMultiple/index.vue';
export default {
  name: 'RuleConditionItem',
  components: { SelectMultiple },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    ruleList: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const rule = this.$attrs.rule || {};
    return {
      rule,
      orAndOptions: [
        { label: '或', value: 'or' },
        { label: '且', value: 'and' },
      ],
    };
  },
  computed: {
    indicatorOptions() {
      return this.options.map(item => {
        return {
          value: item.field,
          label: item.fieldName,
          ...item,
        };
      });
    },
    conditionOptions() {
      if (this.rule.targetField && this.rule.targetField == this.rule.field) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rule.targetField = 1;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rule.targetFieldName = '固定值';
      }

      const conditionList =
        this.indicatorOptions.find(item => {
          return item.value == this.rule.field;
        })?.condition || [];

      return conditionList.map(item => {
        return {
          label: item.name,
          ...item,
        };
      });
    },
    targetFieldOptions() {
      const compareFieldList =
        this.conditionOptions.find(item => {
          return item.value == this.rule.condition;
        })?.compareFieldList || [];

      return compareFieldList.map(item => {
        return {
          label: item.name,
          ...item,
        };
      });
    },
    ruleFiled() {
      return this.rule.field ? { value: this.rule.field, label: this.rule.fieldName } : undefined;
    },
    targetField() {
      if (['IN', 'NOTIN'].includes(this.rule.condition)) {
        if (this.rule.targetField) {
          return this.rule.targetField;
        } else {
          return [];
        }
      } else {
        return this.rule.targetField ? { value: this.rule.targetField, label: this.rule?.targetFieldName } : undefined;
      }
    },
  },
  methods: {
    // 触发条件且或改变
    orAndChange() {
      this.ruleList.forEach(item => {
        item.orAnd = this.rule.orAnd;
      });
    },
    // 指标变化
    fieldChange(val) {
      if (val) {
        this.rule.field = val.value;
        this.rule.fieldName = val.label;
        this.rule.condition = undefined;
        this.rule.targetField = null;
        this.rule.value = undefined;
      }
    },
    // 对比指标变化
    targetFieldChange(val) {
      if (val) {
        this.rule.targetField = val.value;
        this.rule.targetFieldName = val.label;
      }
    },
    // 包含变化
    includeChange(val) {
      this.rule.targetField = val;
      this.rule.value = val.map(item => item.value);
      this.rule.include = val.length ? val.map(item => item.value) : null;
    },
    // 生成输入框后缀，设置valueType
    getSuffix() {
      const valueTypeDict = { RMB: '元', '%': '%' };
      let valueType = this.targetFieldOptions.find(item => {
        return item.value == this.rule.targetField;
      })?.valueType;
      if (valueType) this.rule.valueType = valueType;
      return valueTypeDict[valueType];
    },
    // 控制输入框选择框显隐
    showBox(type) {
      let flag;
      !this.rule.requiredKey && (this.rule.requiredKey = new Map());
      switch (type) {
        case 'field':
          flag = true;
          this.rule.requiredKey.set('field', flag);
          break;
        case 'condition':
          flag = true;
          this.rule.requiredKey.set('condition', flag);
          break;
        case 'targetField':
        case 'value':
          flag = !['IN', 'NOTIN'].includes(this.rule.condition);
          this.rule.requiredKey.set(type, flag);
          break;
        case 'include':
          flag = ['IN', 'NOTIN'].includes(this.rule.condition);
          this.rule.requiredKey.set('include', flag);
          break;
        case 'compareModel':
          const item = this.targetFieldOptions.find(item => item.value == this.rule.targetField);
          if (item?.compareModel) {
            this.rule.compareModel = this.rule.compareModel || item.compareModel[0];
          }
          flag = Boolean(item?.compareModel);
          this.rule.requiredKey.set('compareModel', flag);
          break;
      }
      return flag;
    },
  },
};
</script>

<style scoped lang="less">
</style>
